// Loading service to manage global loading state
// This service provides a way for non-React components (like api_service) to control loading

class LoadingService {
  constructor() {
    this.listeners = [];
    this.isLoading = false;
    this.loadingMessage = 'Loading...';
  }

  // Subscribe to loading state changes
  subscribe(listener) {
    this.listeners.push(listener);
    
    // Return unsubscribe function
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  // Notify all listeners of state change
  notify() {
    this.listeners.forEach(listener => {
      listener({
        isLoading: this.isLoading,
        loadingMessage: this.loadingMessage
      });
    });
  }

  // Show loading with optional message
  showLoading(message = 'Loading...') {
    this.loadingMessage = message;
    this.isLoading = true;
    this.notify();
  }

  // Hide loading
  hideLoading() {
    this.isLoading = false;
    this.loadingMessage = 'Loading...';
    this.notify();
  }

  // Set loading state and message
  setLoading(loading, message = 'Loading...') {
    this.loadingMessage = message;
    this.isLoading = loading;
    this.notify();
  }

  // Get current state
  getState() {
    return {
      isLoading: this.isLoading,
      loadingMessage: this.loadingMessage
    };
  }
}

// Create singleton instance
const loadingService = new LoadingService();

export default loadingService;
